import {
  getHeadline,
  getDiamondArea,
  getActivityCode,
  getDsjapiRecommendList,
  getYyzxParam,
  getYyzxList,
  getLiveList,
  getSearchGoods,
  queryShopList
} from "@/api/index";

export default {
  namespaced: true,
  mutations: {},
  actions: {

    async getHeadline() {
      const { data } = await getHeadline();
      return data;
    },

    async getDiamondArea(context, params) {
      const { data } = await getDiamondArea(params);
      return data;
    },

    async getDsjapiRecommendList(context, params) {
      const { data } = await getDsjapiRecommendList(params);
      return data;
    },

    async getActivityCode() {
      const { data } = await getActivityCode();
      return data;
    },

    async getYyzxParam() {
      const { data } = await getYyzxParam();
      return data;
    },

    async getYyzxList(context, params) {
      const { data } = await getYyzxList(params);
      return data;
    },

    async getLiveList() {
      const { data } = await getLiveList();
      return data;
    },

    async getSearchGoods(context, params) {
      const { data } = await getSearchGoods(params);
      return data;
    },

    async queryShopList(context, params) {
      const res = await queryShopList(params);
      return res;
    }
  }
};
